export const getWordCount = (text_ = "") => {
  let originalText = text_.trim();
  if (originalText === "") {
    return 0
  }
  let wordArray = originalText.split(/\s+/);
  let wordCount = wordArray.length;
  return wordCount;
};
